/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The possible component output html static file types.
 * @export
 */
export type ComponentOutputHtmlStaticFileType =
  | ComponentOutputHtmlStaticFileTypeCss
  | ComponentOutputHtmlStaticFileTypeJs;

/**
 * The html static css file type.
 * @export
 */
export type ComponentOutputHtmlStaticFileTypeCss = typeof COMPONENT_OUTPUT_HTML_STATIC_FILE_TYPE_CSS;

/**
 * The html static js file type.
 * @export
 */
export type ComponentOutputHtmlStaticFileTypeJs = typeof COMPONENT_OUTPUT_HTML_STATIC_FILE_TYPE_JS;

/**
 * The html static css file constant.
 * @export
 */
export const COMPONENT_OUTPUT_HTML_STATIC_FILE_TYPE_CSS = 'css';

/**
 * The html static js file constant.
 * @export
 */
export const COMPONENT_OUTPUT_HTML_STATIC_FILE_TYPE_JS = 'js';
